<div class="flex flex-col relative select-none">
  <div
    class="flex items-center h-[57px] justify-between pl-3 pr-2 py-1 border border-secondary-600 rounded cursor-pointer bg-background-color text-secondary-600 w-full min-w-[100px] transition-all duration-200 ease-in-out hover:bg-background-color hover:opacity-50"
    (click)="toggleDropdown()">
    <div class="flex items-center w-full justify-between pr-2">
      <div class="flex flex-col justify-between gap-2"
        [ngClass]="{'min-w-[40px]': icon === 'currency_exchange', 'min-w-[72px]': icon !== 'currency_exchange'}">
        <div class="w-5 h-5">
          <span class="material-symbols-outlined select-none text-md">{{ icon }}</span>
        </div>
        <div class="flex items-center">
          <span class="text-sm font-medium">
            {{ isPax ? totalPax : '' }}
            {{ text }}{{ isPax && totalPax > 1 ? 's' : '' }}
          </span>
        </div>
      </div>
      <div class="select-none flex justify-center items-center">
        <span class="material-symbols-outlined transition-transform duration-200 ease-in-out"
          [class.rotate-180]="isOpen">keyboard_arrow_down</span>
      </div>
    </div>
  </div>

  @if (isOpen) {
  @if (!isPax) {
  <div class="absolute mt-[57px] w-max bg-primary-50 border rounded shadow-lg z-50">
    <ul class="py-2 z-50" role="radiogroup">
      @for (option of options; track option.value) {
      <li class="flex items-center gap-3 px-4 py-2 hover:bg-primary-100 cursor-pointer" (click)="selectOption(option)">
        <div class="w-5 h-5 rounded-full border-2 flex items-center justify-center" [ngClass]="{
                  'border-neutral-600':
                    selectedOption?.value === option.value,
                  'border-primary-800': selectedOption?.value !== option.value,
                }">
          <div class="w-2.5 h-2.5 rounded-full" [ngClass]="{
                    'bg-neutral-600': selectedOption?.value === option.value,
                    'bg-transparent': selectedOption?.value !== option.value,
                  }"></div>
        </div>
        <span class="text-primary-800 text-xs font-medium">{{
          option.label
          }}</span>
      </li>
      }
    </ul>
  </div>
  } @else {
  <div class="p-4 flex flex-col gap-4 absolute mt-[57px] w-max bg-primary-50 border rounded shadow-lg z-10">
    @for (type of paxTypes; track type.key) {
    <div class="flex gap-4 justify-between items-center">
      <div>
        <p class="text-primary-800 text-sm font-medium">
          {{ type.label }}
          <br />
          <small class="text-primary-400 text-2xs font-medium">{{
            type.description
            }}</small>
        </p>
      </div>
      <div class="rounded-lg border border-neutral-200 flex items-center justify-center">
        <button type="button" mat-icon-button class="p-2.5 leading-none h-10"
          (click)="handlerPax('decrement', type.key)">
          <img [src]="pax[type.key] <= type.min ? minusDisabled : minus" alt="icon" class="w-5 h-5" />
        </button>
        <div class="p-2.5 h-10 w-[58px] bg-neutral-100 text-center border-x border-neutral-200">
          <p class="text-xs text-primary-800 font-medium">
            {{ pax[type.key] }}
          </p>
        </div>
        <button type="button" mat-icon-button class="p-2.5 leading-none h-10" [disabled]="totalPax >= 9"
          (click)="handlerPax('increment', type.key)">
          <img [src]=" totalPax < 9 ? add : addDisabled" alt="icon" class="w-5 h-5" />
        </button>
      </div>
    </div>
    }
    @if(errorPaxs) {
    <div class="text-2xs text-danger-600 font-medium">No pueden viajar más bebés que adultos</div>}
  </div>
  }
  }
</div>